import { ModelAnswerPresenter } from '@/presentation/presenters/modelAnswer/modelAnswerPresenter'
import { ModelAnswerListViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerListViewModel'
import { ModelAnswerPageStateViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerPageStateViewModel'
import { ModelAnswerSourceCodeViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerSourceCodeViewModel'

export function useModelAnswerPresenter(
  presenter: ModelAnswerPresenter = new ModelAnswerPresenter(
    new ModelAnswerPageStateViewModel(),
    new ModelAnswerListViewModel(),
    new ModelAnswerSourceCodeViewModel()
  )
) {
  return {
    initState: presenter.initState.bind(presenter),
    addModelAnswerList: presenter.addModelAnswerList.bind(presenter),
    clickSummary: presenter.clickSummary.bind(presenter)
  }
}
